(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["garment-choices"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
  const link = event.target.closest('[data-garment-size-guide]');
  if (!link) return;
  const anchor = document.getElementById(link.hash.slice(1));
  if (!anchor) return;
  const description = anchor.parentElement.querySelector('.product__description');
  if (!description) return;
  const details = Array.from(description.querySelectorAll('details')).find(item => /size guide/i.test(item.querySelector('summary')?.textContent || ''));
  if (details) details.open = true;
  const destination = details || description.querySelector('.size-guide-title') || description;
  event.preventDefault();
  destination.setAttribute('tabindex', '-1');
  destination.scrollIntoView({block:'center'});
  destination.focus({preventScroll:true});
});
  } catch(e) { console.error(e); }
})();

})();
